import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import DemoPage from "./pages/DemoPage";
import SolutionPage from "./pages/SolutionPage";
import IndustryPage from "./pages/IndustryPage";
import ResourcesPage from "./pages/ResourcesPage";
import ArticlePage from "./pages/ArticlePage";
import PricingPage from "./pages/PricingPage";
import AffiliatePage from "./pages/AffiliatePage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import OptOutPage from "./pages/OptOutPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CompliancePage from "./pages/CompliancePage";
import SecurityPage from "./pages/SecurityPage";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./auth/AuthContext";
import AuthCallback from "./auth/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment synchronously during render (before useEffect runs)
  // Handles the redirect back from Emergent Google Auth.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/login" element={<DemoPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/affiliate" element={<AffiliatePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/optout" element={<OptOutPage />} />
      <Route path="/solutions/:slug" element={<SolutionPage />} />
      <Route path="/industries/:slug" element={<IndustryPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/resources/:slug" element={<ArticlePage />} />
      <Route path="/buyer-intent" element={<SolutionPage />} />
      <Route path="/integrations" element={<SolutionPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/compliance" element={<CompliancePage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
